import {
    Badge,
    Circle,
    IconCloudRegular,
    IconDataBonusRegular,
    IconDeviceSignalRegular,
    IconEuroSymbolCircleRegular,
    IconLockClosedRegular,
    skinVars,
} from '@telefonica/mistica';
import './index.scss';
import { managementEnvironment } from '../../utils/dataTransformation/environments';

interface IRigthIconsConvergent {
    dataSharing?: boolean;
    isBonus: boolean;
    isBadge: boolean;
    isCloud: boolean;
    isBlocked: boolean;
}
const RigthIconsConvergent: React.FC<IRigthIconsConvergent> = ({
    dataSharing,
    isBonus,
    isBadge,
    isCloud,
    isBlocked,
}: IRigthIconsConvergent) => {
    const O2Cloud_home = managementEnvironment().VITE_WEBVIEW_O2CLOUD_HOME_ENABLED;

    return (
        <div className='mobile-section-extra-icons'>
            {O2Cloud_home && (
                <div className='mobile-section-extra-icons-space'>
                    <Circle
                        size={20}
                        backgroundColor={isCloud ? skinVars.colors.successLow : skinVars.colors.neutralLow}
                    >
                        {isCloud && !isBlocked ? (
                            <IconCloudRegular size={18} />
                        ) : (
                            <Badge>
                                <IconCloudRegular size={18} />
                            </Badge>
                        )}
                    </Circle>
                </div>
            )}
            {isBadge && !isBlocked ? (
                <Badge>
                    <IconEuroSymbolCircleRegular size={20} className='mobile-section-extra-icons-space' />
                </Badge>
            ) : (
                ''
            )}
            {dataSharing && !isBlocked && (
                <IconDeviceSignalRegular size={20} className='mobile-section-extra-icons-space' />
            )}
            {isBonus && !isBlocked && <IconDataBonusRegular size={20} />}
            {isBlocked && <IconLockClosedRegular color={skinVars.colors.controlError} size={24} />}
        </div>
    );
};

export default RigthIconsConvergent;
